import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Budget Centrale"
                dataProviderName={'statisticsviews/item/sum/commercials/areaSource/budgetCentrale'}// non mi piace non sia sumfinancial
                filters={filterModel}
                format='currency'
                compactformat={true}
            />
            <KPI
                title="Budget Centrale Eroso"
                dataProviderName={'statisticsviews/item/sum/commercials/areaSource/budgetCentraleErodedStatic'}// non mi piace non sia sumfinancial
                filters={filterModel}
                format='currency'
                compactformat={false}
            />
            <KPI
                title="Budget Centrale Rimanente"
                dataProviderName={'statisticsviews/item/sum/commercials/areaSource/budgetCentraleRemainingStatic'}// non mi piace non sia sumfinancial
                filters={filterModel}
                format='currency'
                compactformat={false}
            />
            
        </Box>
    )
}

export default KPISet;